// PIUM 디자인 시스템 v0.9 - CSS variables 기반 (테마 토글 지원)
// 실제 값은 index.html의 :root[data-theme=dark|light]에 정의

export const C = {
  bg:        'var(--c-bg)',
  surface:   'var(--c-surface)',
  surface2:  'var(--c-surface2)',
  surface3:  'var(--c-surface3)',
  border:    'var(--c-border)',
  borderHi:  'var(--c-border-hi)',
  text:      'var(--c-text)',
  textDim:   'var(--c-text-dim)',
  dim:       'var(--c-dim)',
  dim2:      'var(--c-dim2)',
  // 액센트(고정 - 두 테마 공통)
  gold:      '#C9A84C',
  goldBg:    'rgba(201,168,76,0.14)',
  goldHi:    '#E0BC5C',
  blue:      '#4A8FD4',
  blueBg:    'rgba(74,143,212,0.14)',
  green:     '#52A070',
  greenBg:   'rgba(82,160,112,0.14)',
  red:       '#C05252',
  redBg:     'rgba(192,82,82,0.14)',
  purple:    '#8B52D4',
  purpleBg:  'rgba(139,82,212,0.14)',
  orange:    '#D4834A',
  orangeBg:  'rgba(212,131,74,0.14)',
};

export const USERS = {
  '이팀장': C.gold,
  '박대리': C.blue,
  '김과장': C.green,
  '윤대표': C.purple,
  '최주임': C.orange,
};

export const S = { 1: 4, 2: 8, 3: 12, 4: 16, 5: 20, 6: 24, 7: 32, 8: 48 };
export const R = { sm: 4, md: 6, lg: 8, xl: 12, xxl: 16, pill: 999 };

// 테마 토글 헬퍼
export function applyTheme(theme) {
  if (typeof document !== 'undefined') {
    document.documentElement.dataset.theme = theme;
    try { localStorage.setItem('pium-collab:theme', theme); } catch {}
  }
}

export function loadTheme() {
  try {
    const saved = localStorage.getItem('pium-collab:theme');
    if (saved === 'dark' || saved === 'light') return saved;
  } catch {}
  // OS 다크모드 감지 (Teams가 다크 기본이므로 dark)
  if (typeof window !== 'undefined' && window.matchMedia?.('(prefers-color-scheme: dark)').matches) return 'dark';
  return 'dark';
}
